import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('@/pages/index/index-seven.vue'),
  },
  // {
  //   path: "/index-two",
  //   name: "index-two",
  //   component: () => import('@/pages/index/index-two.vue'),
  // },
  // {
  //   path: "/index-three",
  //   name: "index-three",
  //   component: () => import('@/pages/index/index-three.vue'),
  // },
  // {
  //   path: "/index-four",
  //   name: "index-four",
  //   component: () => import('@/pages/index/index-four.vue'),
  // },
  // {
  //   path: "/index-five",
  //   name: "index-five",
  //   component: () => import('@/pages/index/index-five.vue'),
  // },
  // {
  //   path: "/index-six",
  //   name: "index-six",
  //   component: () => import('@/pages/index/index-six.vue'),
  // },
  // {
  //   path: "/index-seven",
  //   name: "index-seven",
  //   component: () => import('@/pages/index/index.vue'),
  // },
  // {
  //   path: "/index-eight",
  //   name: "index-eight",
  //   component: () => import('@/pages/index/index-eight.vue'),
  // },
  // {
  //   path: "/index-nine",
  //   name: "index-nine",
  //   component: () => import('@/pages/index/index-nine.vue'),
  // },
  // {
  //   path: "/index-ten",
  //   name: "index-ten",
  //   component: () => import('@/pages/index/index-ten.vue'),
  // },
  {
    path: "/job-categories",
    name: "job-categories",
    component: () => import('@/pages/jobs/job-categories.vue'),
  },
  // {
  //   path: "/job-grid-one",
  //   name: "job-grid-one",
  //   component: () => import('@/pages/jobs/job-grid/job-grid-one.vue'),
  // },
  // {
  //   path: "/job-grid-two",
  //   name: "job-grid-two",
  //   component: () => import('@/pages/jobs/job-grid/job-grid-two.vue'),
  // },
  // {
  //   path: "/job-grid-three",
  //   name: "job-grid-three",
  //   component: () => import('@/pages/jobs/job-grid/job-grid-three.vue'),
  // },
  {
    path: "/job-listing",
    name: "job-listing",
    component: () => import('@/pages/jobs/job-grid/job-grid-four.vue'),
  },
  // {
  //   path: "/job-list-one",
  //   name: "job-list-one",
  //   component: () => import('@/pages/jobs/job-list/job-list-one.vue'),
  // },
  // {
  //   path: "/job-list-two",
  //   name: "job-list-two",
  //   component: () => import('@/pages/jobs/job-list/job-list-two.vue'),
  // },
  // {
  //   path: "/job-list-three",
  //   name: "job-list-three",
  //   component: () => import('@/pages/jobs/job-list/job-list-three.vue'),
  // },
  // {
  //   path: "/job-list-four",
  //   name: "job-list-four",
  //   component: () => import('@/pages/jobs/job-list/job-list-four.vue'),
  // },
  // {
  //   path: "/job-list-five",
  //   name: "job-list-five",
  //   component: () => import('@/pages/jobs/job-list/job-list-five.vue'),
  // },
  // {
  //   path: "/job-list-six",
  //   name: "job-list-six",
  //   component: () => import('@/pages/jobs/job-list/job-list-six.vue'),
  // },
  {
    path: "/zuri-hr-job-detail",
    name: "zuri-hr-job-detail",
    component: () => import('@/pages/jobs/job-detail/job-detail-one.vue'),
  },
  {
    path: "/zuri-hr-job-detail/:id",
    name: "zuri-hr-job-detail",
    component: () => import('@/pages/jobs/job-detail/job-detail-one.vue'),
  },
  // {
  //   path: "/job-detail-two",
  //   name: "job-details-two",
  //   component: () => import('@/pages/jobs/job-detail/job-detail-two.vue'),
  // },
  // {
  //   path: "/job-detail-two/:id",
  //   name: "job-detail-two",
  //   component: () => import('@/pages/jobs/job-detail/job-detail-two.vue'),
  // },
  // {
  //   path: "/job-detail-three",
  //   name: "job-details-three",
  //   component: () => import('@/pages/jobs/job-detail/job-detail-three.vue'),
  // },
  // {
  //   path: "/job-detail-three/:id",
  //   name: "job-detail-three",
  //   component: () => import('@/pages/jobs/job-detail/job-detail-three.vue'),
  // },
  {
    path: "/job-apply",
    name: "job-applys",
    component: () => import('@/pages/jobs/job-apply.vue'),
  },
  {
    path: "/job-apply/:id",
    name: "job-apply",
    component: () => import('@/pages/jobs/job-apply.vue'),
  },
  // {
  //   path: "/job-post",
  //   name: "job-post",
  //   component: () => import('@/pages/jobs/job-post.vue'),
  // },
  // {
  //   path: "/career",
  //   name: "career",
  //   component: () => import('@/pages/jobs/career.vue'),
  // },
  {
    path: "/aboutus",
    name: "aboutus",
    component: () => import('@/pages/pages/aboutus.vue'),
  },
  // {
  //   path: "/services",
  //   name: "services",
  //   component: () => import('@/pages/pages/services.vue'),
  // },
  // {
  //   path: "/pricing",
  //   name: "pricing",
  //   component: () => import('@/pages/pages/pricing.vue'),
  // },
  // {
  //   path: "/employer-list",
  //   name: "employer-list",
  //   component: () => import('@/pages/pages/employers/employer-list.vue'),
  // },
  // {
  //   path: "/employer-detail",
  //   name: "employer-details",
  //   component: () => import('@/pages/pages/employers/employer-detail.vue'),
  // },
  // {
  //   path: "/employer-detail/:id",
  //   name: "employer-detail",
  //   component: () => import('@/pages/pages/employers/employer-detail.vue'),
  // },
  // {
  //   path: "/candidate-list",
  //   name: "candidate-list",
  //   component: () => import('@/pages/pages/candidates/candidate-list.vue'),
  // },
  // {
  //   path: "/candidate-profile",
  //   name: "candidate-profiles",
  //   component: () => import('@/pages/pages/candidates/candidate-profile.vue'),
  // },
  // {
  //   path: "/candidate-profile/:id",
  //   name: "candidate-profile",
  //   component: () => import('@/pages/pages/candidates/candidate-profile.vue'),
  // },
  // {
  //   path: "/candidate-profile-setting",
  //   name: "candidate-profile-setting",
  //   component: () => import('@/pages/pages/candidates/candidate-profile-setting.vue'),
  // },
  // {
  //   path: "/helpcenter-overview",
  //   name: "helpcenter-overview",
  //   component: () => import('@/pages/pages/helpcenter/helpcenter-overview.vue'),
  // },
  // {
  //   path: "/helpcenter-faqs",
  //   name: "helpcenter-faqs",
  //   component: () => import('@/pages/pages/helpcenter/helpcenter-faqs.vue'),
  // },
  // {
  //   path: "/helpcenter-guides",
  //   name: "helpcenter-guides",
  //   component: () => import('@/pages/pages/helpcenter/helpcenter-guides.vue'),
  // },
  // {
  //   path: "/helpcenter-support",
  //   name: "helpcenter-support",
  //   component: () => import('@/pages/pages/helpcenter/helpcenter-support.vue'),
  // },
  // {
  //   path: "/blogs",
  //   name: "blogs",
  //   component: () => import('@/pages/pages/blogs/blogs.vue'),
  // },
  // {
  //   path: "/blog-detail/:id",
  //   name: "blog-detail",
  //   component: () => import('@/pages/pages/blogs/blog-detail.vue'),
  // },
  // {
  //   path: "/blog-detail",
  //   name: "blog-details",
  //   component: () => import('@/pages/pages/blogs/blog-detail.vue'),
  // },
  // {
  //   path: "/login",
  //   name: "login",
  //   component: () => import('@/pages/auth-pages/login.vue'),
  // },
  // {
  //   path: "/signup",
  //   name: "signup",
  //   component: () => import('@/pages/auth-pages/signup.vue'),
  // },
  // {
  //   path: "/reset-password",
  //   name: "reset-password",
  //   component: () => import('@/pages/auth-pages/reset-password.vue'),
  // },
  // {
  //   path: "/lock-screen",
  //   name: "lock-screen",
  //   component: () => import('@/pages/auth-pages/lock-screen.vue'),
  // },
  // {
  //   path: "/signup-success",
  //   name: "signup-success",
  //   component: () => import('@/pages/auth-pages/signup-success.vue'),
  // },
  // {
  //   path: "/terms",
  //   name: "terms",
  //   component: () => import('@/pages/utility/terms.vue'),
  // },
  // {
  //   path: "/privacy",
  //   name: "privacy",
  //   component: () => import('@/pages/utility/privacy.vue'),
  // },
  {
    path: "/comingsoon",
    name: "comingsoon",
    component: () => import('@/pages/special-page/comingsoon.vue'),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => import('@/pages/special-page/maintenance.vue'),
  },
  {
    path: "/thankyou",
    name: "thankyou",
    component: () => import('@/pages/special-page/thankyou.vue'),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import('@/pages/contact.vue'),
  },
  // {
  //   path: "/validation",
  //   name: "validation",
  //   component: () => import('@/pages/validation.vue'),
  // },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import('@/pages/special-page/error.vue'),
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;